














































import {Component, Vue, Watch} from "vue-property-decorator";
import {DivisionPickupStatus} from "@/enums/status";
import debounce from "lodash/debounce";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {EmployeeType} from "@/enums/type";
import {DivisionPickupParams} from "../../params";
import {DivisionPickupStore} from "@/modules/divisionpickup/store";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";


@Component({
  name: "DivisionPickupSearch",
  components: {CustomerSelector, EmployeeSelector, EnumSelector, MillisecondDatePicker}
})
export default class extends Vue {
  DivisionPickupStatus = DivisionPickupStatus;
  limitStatus = [
    DivisionPickupStatus.ChoXacNhan,
    DivisionPickupStatus.XacNhanLay,
      DivisionPickupStatus.ShipperHuy,
      DivisionPickupStatus.LayThanhCong
  ];
  private form = {
    ...new DivisionPickupParams()
  }
  EmployeeType = EmployeeType;
  
  // created() {
  //     Vue.set(this.form, 'fromDate', (new Date()).valueOf());
  // }
  
  @Watch('form', {immediate: false, deep: true})
  onValuesChange(val: any) {
    this.handleChange(val);
  }
  
  handleChange = debounce(function (val) {
    const limitStatus = [
      DivisionPickupStatus.ChoXacNhan,
      DivisionPickupStatus.XacNhanLay,
      DivisionPickupStatus.ShipperHuy
    ];
    DivisionPickupStore.updateDivisionPickupParams(val);

    if (val.status)
      DivisionPickupStore.listDivisionPickup({...val, page: 1});
    else
      DivisionPickupStore.listDivisionPickup({...val, page: 1, statusString: limitStatus.join(",")});
    
  }, 500);
}
